




















import { Component, Vue, Prop } from 'vue-property-decorator';
import ACActions from './ACActions.vue';
import ConversationList from './ConversationList.vue';
import { Conversation } from './type';
import ArticleAutocomplete from '@/components/ArticleAutocomplete.vue';

@Component({ components: { ConversationList, ACActions, ArticleAutocomplete } })
export default class ActiveConversations extends Vue {
  @Prop({ default: 0 }) readonly count!: number;
  @Prop({ default: () => [] }) readonly conversations!: Conversation[];
  @Prop({ default: 99999 }) readonly maxLimit!: number;

  created () {
    document.title = 'Active Conversations';
  }
}
